import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
const originalPush = VueRouter.prototype.push;
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
const postId = localStorage.getItem("iuPost")*1;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};


Vue.use(VueRouter);
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/dologin",
  },

  {
    path: "/dologin",
    name: "dologin",
    component: () => import("../views/doLogin.vue"),
    meta: {
      title: "登录",
    },
  },

  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "",
        redirect: '/Home/userList',
      },
      {
        path: "userList",
        name: "userList",
        component: () => import("../views/user/userList"),
      },
      {
        path: "department",
        name: "department",
        component: () => import("../views/department/department"),
      },
      {
        path: "agent",
        name: "agent",
        component: () => import("../views/agent/agent"),
      },
      {
        path: "knowledgeBaseType",
        name: "knowledgeBaseType",
        component: () => import("../views/knowledgeBase/knowledgeBaseType"),
      },
      {
        path: "knowledgeBaseList",
        name: "knowledgeBaseList",
        component: () => import("../views/knowledgeBase/knowledgeBaseList"),
      },
       {
        path: "agentType",
        name: "agentType",
        component: () => import("../views/agentType/agentType"),
      },
       {
        path: "chatMsgList",
        name: "chatMsgList",
        component: () => import("../views/chatMsgList/chatMsgList"), 
      },
    ]
  },
];

const router = new VueRouter({
  routes,
});

export default router;
